import { useMemo, useState } from 'react';
import { useQuery } from '@apollo/client';
import {
  IRolesQuery,
  IRolesQueryVariables,
} from '../../../utils/apollo/graphqlSchema';
import { GET_ROLES } from '../../../utils/apollo/permission';
import { useDebounce } from '../../../utils/hooks';
import { ICapricaTableStatus } from '../types';

const useRoleList = () => {
  const [statuses, setStatuses] = useState<ICapricaTableStatus[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchQuery = useDebounce(searchTerm, 300);

  const { data, refetch, loading } = useQuery<
    IRolesQuery,
    IRolesQueryVariables
  >(GET_ROLES, {
    variables: {
      pagination: {
        first: 50,
        after: 0,
      },
      term: debouncedSearchQuery,
      includes: [],
      includeDisabled: true,
    },
  });

  const entities = data?.roles?.entities;

  const roles = useMemo(() => {
    if (!entities?.length) {
      return [];
    }

    if (!statuses.length) {
      return entities;
    }

    return entities.filter((entity) => {
      if (
        statuses.includes(ICapricaTableStatus.Active) &&
        statuses.includes(ICapricaTableStatus.Disabled)
      ) {
        return true;
      }

      if (statuses.includes(ICapricaTableStatus.Active)) {
        return entity.active;
      }

      if (statuses.includes(ICapricaTableStatus.Disabled)) {
        return !entity.active;
      }

      return false;
    });
  }, [entities, statuses]);

  const total = roles.length;

  return {
    loading,
    refetch,
    searchTerm,
    setSearchTerm,
    roles,
    total,
    statuses,
    setStatuses,
  };
};

export default useRoleList;
